import React from 'react';
import styled from 'styled-components';
import { formatCents } from '@src/common';
import { device } from '@src/common/breakpoints';
import { useAppSelector, useTranslate } from '@src/core/hooks';
import { useWidgetId } from '@src/core/IdProvider';
import { adderResumeSelector, productAdderStepState } from '@src/stores/product';
import { BodyRegular, Heading6 } from '@src/fonts/typography/Typography';
import { DarkTextColor } from '@src/fonts/typography/TypographyColors';
import ProductAdderNextStepButton from './ProductAdderNextStepButton';
import ProductAdderPreviousStepButton from './ProductAdderPreviousStepButton';

interface ProductAdderFooterButtonsProps {
  showValue?: boolean;
  disableNextStepButton?: boolean;
  isMultiProductFlow?: boolean;
}

const ProductAdderFooterButtons = (props: Readonly<ProductAdderFooterButtonsProps>) => {
  const { showValue, disableNextStepButton = false, isMultiProductFlow = false } = props;
  const widgetId = useWidgetId();
  const { totalCents } = useAppSelector(adderResumeSelector(widgetId));
  const { i18n } = useTranslate();
  const { steps, currentStep } = useAppSelector(productAdderStepState(widgetId));
  const showPreviousStepButton = steps[0] !== currentStep;

  return (
    <ProductAdderFooterButtonsArea>
      {showValue && !isMultiProductFlow ? (
        <ProductAdderFooterTotalArea>
          <ProductAdderFooterTotalLabel>{i18n('sale_totalValue')}</ProductAdderFooterTotalLabel>
          <ProductAdderFooterTotalValue>{formatCents(totalCents)}</ProductAdderFooterTotalValue>
        </ProductAdderFooterTotalArea>
      ) : null}
      <Bar />
      <ButtonArea>
        {showPreviousStepButton && <ProductAdderPreviousStepButton />}
        <ProductAdderNextStepButton disabled={disableNextStepButton} />
      </ButtonArea>
    </ProductAdderFooterButtonsArea>
  );
};

const ProductAdderFooterTotalArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-end;
`;
const ProductAdderFooterTotalLabel = styled.p`
  ${Heading6}
  ${DarkTextColor}
`;
const ProductAdderFooterTotalValue = styled.p`
  ${BodyRegular}
  ${DarkTextColor}
    margin-bottom: 1vh;
`;

const ProductAdderFooterButtonsArea = styled.div`
  padding-top: 1.5vh;
`;

const Bar = styled.div`
  border-bottom: 1px solid #aaaaaa;
  margin-bottom: 1.5vh;
`;
const ButtonArea = styled.div`
  display: flex;
  flex-direction: column-reverse;
  gap: 16px;
  flex-wrap: wrap;
  justify-content: center;
  align-items: stretch;
  ${device.smallTablet} {
    flex-direction: row;
    align-items: center;
    button {
      width: 205px;
    }
  }
`;
export default ProductAdderFooterButtons;
